var _rect, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWalletV2 = function SvgWalletV2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    preserveAspectRatio: "none",
    viewBox: "0 0 22 20"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 15,
    x: 1,
    y: 3,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M1 8h20"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 13,
    r: 1.5,
    fill: "currentColor"
  })));
};
export default SvgWalletV2;